import { useContext } from 'react';
import { EventTileGroup } from 'components/UI/EventTileGroup/EventTileGroup';
import { EventTile } from 'components/UI/EventTile/EventTile';
import { Button } from 'components/UI/Button/Button';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';
import './SearchResultsEvents.scss';

export const SearchResultsEvents = () => {
  const { eventsData, searchString, loadMoreEventsButtonHandler } =
    useContext(SearchContext);

  const events = eventsData?.events;
  const eventsCount = events?.length;
  const totalResults = eventsData?.totalResults;

  if (!eventsCount) {
    return null;
  }

  const eventsResultContent = (
    <>
      <div className="event-results__heading">
        <p className="h4" data-testid="results-count">
          {eventsCount} of {totalResults} event results for "{searchString}"
        </p>
        <h2
          className="event-results__heading--centered h3 text-center"
          data-testid="section-title"
        >
          Events
        </h2>
      </div>

      <EventTileGroup collapseOnMobile>
        {events?.map((event, index) => (
          <EventTile {...event} key={index} collapseOnMobile />
        ))}
      </EventTileGroup>

      {totalResults > eventsCount ? (
        <div className="fullwidth-container text-center">
          <Button
            onClick={loadMoreEventsButtonHandler}
            text="Load more events"
            variant="primary"
            extendClass="btn-small load-more-events"
          />
        </div>
      ) : null}
    </>
  );

  return (
    <section
      className="event-results__container container"
      data-testid="search-results"
    >
      {eventsResultContent}
    </section>
  );
};
